import Component from '@bythepixel/component-loader';

export default class LongFormContent extends Component {
  static loaderPriority = 'in-view';
  static selector = '[data-comp-long-form-content]';

  constructor(containerEl) {
    super(containerEl);
    this.navLinks = this.$container.querySelectorAll('[data-long-form-content-nav-link]');
    this.sections = this.$container.querySelectorAll('[data-long-form-content-section]');
    this.activeNavLinkClass = 'long-form-content-navigation__link--active';
    this.addScrollListener();
    this.addNavLinkListeners();
  }

  addScrollListener() {
    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        const parentTop = this.sections[0].parentElement.offsetTop;
        const firstSectionTop = this.sections[0].offsetTop + parentTop;
        const lastSection = this.sections[this.sections.length - 1];
        const lastSectionBottom = lastSection.offsetTop + parentTop + lastSection.offsetHeight;
        // Get top of window plus 200 pixels
        const currentScrollTop = window.scrollY + 200;
        if (currentScrollTop > firstSectionTop && currentScrollTop < lastSectionBottom) {
          this.sections.forEach(section => {
            const sectionTop = section.offsetTop + parentTop;
            const sectionBottom = sectionTop + section.offsetHeight;
            if (currentScrollTop >= sectionTop && sectionBottom >= currentScrollTop) {
              const sectionId = section.getAttribute('id');
              this.navLinks.forEach(navLink => {
                if (navLink.getAttribute('href').replace('#', '') === sectionId) {
                  navLink.classList.add(this.activeNavLinkClass);
                } else {
                  navLink.classList.remove(this.activeNavLinkClass);
                }
              });
            }
          });
        } else {
          this.removeActiveClassFromAllLinks();
        }
      });
    });
  }

  addNavLinkListeners() {
    this.navLinks.forEach(link => {
      link.addEventListener('click', () => {
        window.setTimeout(() => this.hashChangeScroll(), 0);
      });
    });
    // If there is a hash already in the URL when page is loaded, scroll to that section
    window.setTimeout(() => this.hashChangeScroll(), 500);
  }

  hashChangeScroll() {
    if (window.location.hash.length !== 0) {
      const parentTop = this.sections[0].parentElement.offsetTop;
      const link = window.location.hash;
      const section = this.$container.querySelector(link);
      const sectionTop = section.offsetTop;
      // Add an extra 1px in the scrollTo to make sure the link gets the active class
      window.scrollTo(window.scrollX, sectionTop + parentTop + 1);
    }
  }

  removeActiveClassFromAllLinks() {
    this.navLinks.forEach(navLink => {
      navLink.classList.remove(this.activeNavLinkClass);
    });
  }
}
